import { View, Text } from '@react-pdf/renderer';
import { DocumentState } from '../../../common';
import { BadgeData, getDataByStatus } from './Badge.utils';
import { styles } from './Badge.module';

interface BadgeProps {
  documentState: DocumentState;
}

export const Badge = ({ documentState }: BadgeProps) => {
  const badgeData: BadgeData = getDataByStatus(documentState);

  return (
    !!badgeData && (
      <View
        style={[
          styles.container,
          {
            backgroundColor: badgeData.backgroundColor,
            border: `1px solid ${badgeData.borderColor ? badgeData.borderColor : badgeData.backgroundColor}`,
          },
        ]}
      >
        <Text style={[styles.label, { color: badgeData.color }]}>{badgeData.label}</Text>
      </View>
    )
  );
};
